import { Injectable } from '@angular/core';
import { SelectListItemViewModel } from '../business-entities/select-list-item-view-model';
import { DealerRequestModel, DealerViewModel } from './../business-entities/dealer-view-model';
import { DealerBusinessService } from './dealer.service'

@Injectable({
    providedIn: 'root'
})

export class DealerSearchService {
    dealerValues: DealerViewModel[];
    dealerList: Array<SelectListItemViewModel>;
    constructor(private dealerBusinessService: DealerBusinessService){
    }
    async getDealerList(dealerRequestModel:DealerRequestModel) {
        await this.dealerBusinessService.getDealerList(dealerRequestModel).then((response) => {
          this.dealerValues = response;
        })
        this.dealerList = this.mapdealer(this.dealerValues);
        if(this.dealerList && this.dealerList.length > 0){
            return this.dealerList
        }
      }
      mapdealer(array: DealerViewModel[]){
        let supperArray = [];
        if (array && array.length > 0) {
          array.forEach(element => {
            let single = Object();
            single.value = element.dealerId;
            single.text = element.name;
    
            supperArray.push(single);
          })
        }
        return supperArray;
      }
}